import { CompanySettingModal } from './CompanySettingModal';
import { withCompanySettingModal } from './withCompanySettingModal';

const ConnectedCompanySettingModal = withCompanySettingModal(
  CompanySettingModal
);

export { ConnectedCompanySettingModal as CompanySettingModal };
